import React, { useState, useRef, useEffect } from "react";
import { LogOut } from "lucide-react";
import profile_img from "../../assets/images/profileimage.webp";

export default function SidebarProfile({
  userName,
  userEmail,
  handleLogout,
}) {
  const [profileOpen, setProfileOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleProfile = () => {
    setProfileOpen(!profileOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setProfileOpen(false);
      }
    };

    if (profileOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [profileOpen]);

  return (
    <div className="relative border-t border-gray-100 bg-white">
      {/* Profile trigger */}
      <div
        ref={buttonRef}
        onClick={toggleProfile}
        className="flex flex-col items-center space-y-2 cursor-pointer hover:bg-gray-50 py-2"
      >
        <img
          src={profile_img}
          alt="User"
          className="w-8 h-8 rounded-full object-cover"
        />
        <p className="text-xs text-gray-700 font-medium truncate w-20 text-center">
          {userName ? userName.charAt(0).toUpperCase() + userName.slice(1) : ""}
        </p>
      </div>

      {/* Profile dropdown - positioned to the right */}
      {profileOpen && (
        <div
          ref={dropdownRef}
          className="absolute bottom-0 left-full ml-2 bg-white shadow-lg border border-gray-200 rounded w-48 z-50 p-3"
          style={{
            animation: "fadeIn 0.2s ease-out"
          }}
        >
          <div className="mb-3">
            <p className="text-sm font-semibold text-gray-800 truncate">
              {userName ? userName.charAt(0).toUpperCase() + userName.slice(1) : "User"}
            </p>
            <p className="text-xs text-gray-500 truncate mt-1">{userEmail}</p>
          </div>

          <button
            onClick={() => {
              handleLogout();
              setProfileOpen(false);
            }}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 text-sm text-white bg-primary rounded"
          >
            <LogOut size={16} /> Logout
          </button>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateX(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  );
}